import * as yup from "yup";

const REQUIRED_MESSAGE = "This field is required";

export const teamMemberSchema = yup.object({
  name: yup.string().required(REQUIRED_MESSAGE),
  position: yup.string().required(REQUIRED_MESSAGE),
  displayOrder: yup
    .number()
    .typeError("Display order must be a number")
    .min(0, "Display order must be 0 or greater")
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value)),
});
